import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgxMaskModule } from 'ngx-mask';
import { FlagComponentModule } from '../flag-component/flag-component.module';
import { ValidMsgModule } from '../valid-msg/valid-msg.module';
import { InputDropdownCountryPrefixPhoneComponent } from './input-dropdown-country-prefix-phone.component';

@NgModule({
  imports: [
    CommonModule,
    NgxMaskModule.forRoot({}),
    ReactiveFormsModule,
    NgZorroAntdModule,
    FlagComponentModule,
    ValidMsgModule
  ],
  declarations: [ InputDropdownCountryPrefixPhoneComponent ],
  exports: [ InputDropdownCountryPrefixPhoneComponent ]
})
export class InputDropdownCountryPrefixPhoneModule {}
